import { render, staticRenderFns } from "./sex.vue?vue&type=template&id=64edadd6"
import script from "./sex.vue?vue&type=script&lang=js"
export * from "./sex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports